export default __webpack_public_path__ + "static/media/Pin_Job_Fuel_Large.16be6a71.svg";